import React from 'react';

interface StatItem {
  label: string;
  value: string | number;
}

interface GraphStatsFooterProps {
  stats: StatItem[];
}

export default function GraphStatsFooter({ stats }: GraphStatsFooterProps) {
  return (
    <div className="px-8 py-3 flex gap-8 border-b border-ctu-border bg-background">
      {stats.map(({ label, value }) => (
        <div key={label} className="flex items-baseline gap-2">
          <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ctu-text-muted">
            {label}
          </span>
          <span className="font-mono tabular-nums text-sm text-ctu-text">
            {value}
          </span>
        </div>
      ))}
    </div>
  );
}
